import { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { handleDetailInfoModalOpened } from "@/src/store/listingDetail";

import { poiTypes } from "src/utils/constants/poi-types";

import Loading from "components/common/loading-spinner";

import styles from "./styles.module.css";

const NearbyLocation = ({ location = {}, poiList = [] }) => {
  const mapRef = useRef(null);
  const dispatch = useDispatch();
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const [loading, setLoading] = useState(true);
  const { lat, lon } = location;
  const initializeMapScript = () => {
    const MAP_API_KEY = window.env.EJ_YANDEX_API_KEY;

    if (!window.ymaps) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = `https://api-maps.yandex.ru/2.1/?apikey=${MAP_API_KEY}&lang=en_US`;
      const partOfScript = document.getElementsByTagName("script")[0];
      partOfScript.parentNode.insertBefore(script, partOfScript);

      script.addEventListener("load", () => {
        setIsScriptLoaded(true);
      });
    } else {
      setIsScriptLoaded(true);
      onScriptLoad();
    }
  };

  const onScriptLoad = () => {
    if (mapRef.current) {
      mapRef.current.destroy();
      mapRef.current = null;
    }

    const mapDiv = document.getElementById("nearbyLocation");
    if (mapDiv) {
      mapDiv.innerHTML = "";
    }

    window.ymaps.ready(() => {
      mapRef.current = new window.ymaps.Map("nearbyLocation", {
        center: location,
        zoom: 15,
        controls: [],
      });

      if (location) {
        setPreloadLocation(location);

        const myPlacemark = new window.ymaps.Placemark(
          [lat, lon],
          {},
          {
            iconLayout: "default#image",
            iconImageHref: "/assets/images/map/emlakjet-map-center.png",
            iconImageSize: [40, 52],
            hideIconOnBalloonOpen: false,
          }
        );

        mapRef.current.geoObjects.add(myPlacemark);

        onLoadPoiesToMap();
      }

      const controlElement = document.querySelector(".ymaps-2-1-79-controls-pane");
      if (controlElement) {
        controlElement.style.top = "50px";
      }
      setLoading(false);
    });
  };

  const setPreloadLocation = (currentLocations) => {
    const { lat, lon } = currentLocations;
    if (mapRef.current) {
      mapRef.current.setCenter([lat, lon], 16);
    }
  };

  const onLoadPoiesToMap = () => {
    if (!mapRef.current) return;

    if (poiList?.length > 0) {
      poiList.map((eachPoiList) => {
        const imageHref = poiTypes.find((poi) => poi.id === eachPoiList.categoryId).placemarkImageHref;
        return eachPoiList.poies.map((poi) => {
          const {
            name,
            distance,
            coordinates: { lat, lon },
          } = poi || {};
          const poiPlaceMark = new window.ymaps.Placemark(
            [lat, lon],
            {
              hintContent: `<div style="font-family: 'Open Sans', sans-serif; text-align: center"><p style="font-weight:600">${name}</p> <p style="font-size: 11px; color: #5F787E; font-weight: 600">${distance} uzaklığında</p></div>`,
            },
            {
              iconLayout: "default#image",
              iconImageHref: imageHref,
              iconImageSize: [35, 35],
              hideIconOnBalloonOpen: false,
            }
          );
          return mapRef.current.geoObjects.add(poiPlaceMark);
        });
      });
    }
  };

  useEffect(() => {
    if (!isScriptLoaded) {
      initializeMapScript();
    } else {
      onScriptLoad();
    }
    return () => {
      if (mapRef.current) {
        mapRef.current.destroy();
        mapRef.current = null;
      }
      const mapDiv = document.getElementById("nearbyLocation");
      if (mapDiv) {
        mapDiv.innerHTML = "";
      }
    };
  }, [isScriptLoaded]);

  return (
    <div id="nearbyLocation" className={styles.mapWrap}>
      <>
        {loading ? (
          <div className={styles.loadingContainer}>
            <Loading loadingClass={styles.loading} />
          </div>
        ) : (
          <div className={styles.fullScreenWrapper} onClick={() => dispatch(handleDetailInfoModalOpened("map"))}>
            <img src="/assets/icons/map/full_screen.svg" alt="full_screen.svg" />
          </div>
        )}
      </>
    </div>
  );
};

NearbyLocation.propTypes = {
  location: PropTypes.object.isRequired,
  poies: PropTypes.array,
  poiList: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default NearbyLocation;
